'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 20,
    bottom: 50,
    left: 60,
    right: 15
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    yNumberOfTicks: 5,
    yAxisShift: 0,
    yAxisLabelShift: 45
  };
};
module.exports = Params;